import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TooltipModule } from 'primeng/tooltip';
import { WorkspaceSearchToolboxComponentModule } from '../../workspace-search-toolbox/workspace-search-toolbox.module';
import { WorkspaceListToolbarComponent } from './workspace-list-toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WorkspaceSearchToolboxComponentModule,
    TooltipModule,
    InputTextModule,
    DropdownModule,
    ButtonModule,
    SelectButtonModule,
    TranslateModule,
    RouterModule,
  ],
  declarations: [WorkspaceListToolbarComponent],
  exports: [WorkspaceListToolbarComponent],
})
export class WorkspaceListToolbarComponentModule {}
